// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__lVPio","fileIcon":"styles_fileIcon__7lUN_","header":"styles_header__NNVsi","content":"styles_content__CLFPL","networkIcon":"styles_networkIcon__By6S2"};